// extracted by mini-css-extract-plugin
export var badge = "_gq-2";
export var detailsPanel = "_gq-0";
export var resultRow = "_gq-1";